/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LeadCodeImport } from './routes/$leadCode'
import { Route as IndexImport } from './routes/index'
import { Route as PartnerPositionIdImport } from './routes/partner/$positionId'

// Create/Update Routes

const LeadCodeRoute = LeadCodeImport.update({
  id: '/$leadCode',
  path: '/$leadCode',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const PartnerPositionIdRoute = PartnerPositionIdImport.update({
  id: '/partner/$positionId',
  path: '/partner/$positionId',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/$leadCode': {
      id: '/$leadCode'
      path: '/$leadCode'
      fullPath: '/$leadCode'
      preLoaderRoute: typeof LeadCodeImport
      parentRoute: typeof rootRoute
    }
    '/partner/$positionId': {
      id: '/partner/$positionId'
      path: '/partner/$positionId'
      fullPath: '/partner/$positionId'
      preLoaderRoute: typeof PartnerPositionIdImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$leadCode': typeof LeadCodeRoute
  '/partner/$positionId': typeof PartnerPositionIdRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$leadCode': typeof LeadCodeRoute
  '/partner/$positionId': typeof PartnerPositionIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/$leadCode': typeof LeadCodeRoute
  '/partner/$positionId': typeof PartnerPositionIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/$leadCode' | '/partner/$positionId'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/$leadCode' | '/partner/$positionId'
  id: '__root__' | '/' | '/$leadCode' | '/partner/$positionId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LeadCodeRoute: typeof LeadCodeRoute
  PartnerPositionIdRoute: typeof PartnerPositionIdRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LeadCodeRoute: LeadCodeRoute,
  PartnerPositionIdRoute: PartnerPositionIdRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/$leadCode",
        "/partner/$positionId"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/$leadCode": {
      "filePath": "$leadCode.tsx"
    },
    "/partner/$positionId": {
      "filePath": "partner/$positionId.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
